import React from 'react';
import { CheckoutButton } from '../CheckoutButton';
export function AuthorSection() {
  return <section className="bg-white px-4 py-14 sm:py-20" data-id="element-64" data-mp="3m7s4c5iny828">
      <div className="mx-auto w-full max-w-4xl" data-id="element-65" data-mp="3m67aki46at5f">
        <div className="text-center" data-id="element-66" data-mp="3qyqqhlqc20de">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-aqua-500" data-id="element-67" data-mp="3qzsboj12c38u">
            🦷 About the author
          </p>
          <h2 className="mt-3 font-display text-[28px] font-bold leading-[1.12] tracking-tight text-navy-900 sm:text-4xl" data-id="element-68" data-mp="2yal46ujms3bg">
            Meet Dr. Karito
          </h2>
          <p className="mt-2 text-[15px] text-navy-800/65" data-id="element-69" data-mp="33bilz60qavcf">The educator behind PROSTHO 360™</p>
        </div>

        <div className="mt-8 grid gap-6 md:grid-cols-[minmax(0,320px)_minmax(0,1fr)] md:items-start md:gap-9" data-id="element-70" data-mp="38avh0e1r78q3">
          <img src="https://cdn.magicpatterns.com/uploads/cZyBYHkMqRWksfMJsakmCs/Dra._Karito_Odontologa_OF.png" alt="Dr. Karito, dental educator and author of PROSTHO 360" loading="lazy" className="w-full rounded-3xl bg-sand-100 object-cover shadow-card" data-id="element-71" data-mp="nia66i8rj8bl" />

          <div className="space-y-4 text-[15px] leading-relaxed text-navy-800/75" data-id="element-72" data-mp="1z8ifqwxcthc4">
            <p data-id="element-73" data-mp="1v7f1geuyftd0">
              Over the years, Dr. Karito noticed a common challenge among dental students: Prosthodontics is
              not necessarily difficult because there is too little information—it is difficult because there
              is so much information to organize, connect, and remember.
            </p>
            <p data-id="element-74" data-mp="1giae6j9ayyy1">
              Lectures, textbooks, clinical notes, diagrams, classifications, materials, techniques, and
              procedures can quickly become overwhelming. And when exam time comes, many students find
              themselves asking the same question:
            </p>
            <p className="rounded-2xl bg-sand-50 p-4 font-display text-[19px] font-bold italic leading-snug text-navy-900 ring-1 ring-navy-800/8 sm:text-2xl" data-id="element-75" data-mp="12jaqbdtm6o2x">
              “What should I study first?”
            </p>
            <p data-id="element-76" data-mp="nv0xfposay09">
              That question inspired the creation of PROSTHO 360™, built around a simple principle:{' '}
              <strong className="font-bold text-navy-900" data-id="element-77" data-mp="swq8v6fx5dov">
                you don't always need more information—you need a better way to organize the information you
                already have.
              </strong>
            </p>
            <p data-id="element-78" data-mp="16mjz9t72o60p">
              Instead of another traditional textbook or lengthy course, PROSTHO 360™ was designed as a
              practical visual study system built around maps, comparisons, decision pathways, checklists,
              active recall, and rapid-review tools.
            </p>
            <p className="font-semibold text-navy-900" data-id="element-79" data-mp="11vtwmnq16h9p">
              Welcome to a clearer way to study Prosthodontics.
            </p>
            <p className="text-[14px] font-bold uppercase tracking-wide text-aqua-500" data-id="element-80" data-mp="1pl651ldjalay">
              — Dr. Karito · Author &amp; Dental Educator
            </p>
          </div>
        </div>

        <div className="mt-9" data-id="element-81" data-mp="3f1ruxfu125qn">
          <CheckoutButton label="Start studying with Dr. Karito's system" sub="Instant access · $27 one-time payment" data-id="element-82" data-mp="3f0yxx6kveulp" />
        </div>
      </div>
    </section>;
}